import { inject } from 'tsyringe'
import { containerScoped } from '~/decorators/dependency-container'
import { toCamelCase } from '~/utils/object'
import RequestBuilder from '~/builders/http/RequestBuilder'
import { FormCategory, FormClassified } from '~/models/classified/form'
import { CompactPage } from '~/models/common/types'
import { ClassifiedEditMarketplaceInfo } from '~/models/classified/edit'

@containerScoped()
export default class ClassifiedEditService {
  constructor(@inject(RequestBuilder) private requestBuilder: RequestBuilder) {}

  getEditInfo(
    classifiedId: number | string
  ): Promise<{
    data: {
      category: FormCategory
      registerReferenceCode: string
      classified: FormClassified
      allCategories: FormCategory[]
      marketplace: ClassifiedEditMarketplaceInfo
    }
    page: CompactPage
  }> {
    return this.requestBuilder
      .request('get', `/api/classifieds/${classifiedId}/edit/`)
      .map(body => ({
        data: {
          ...toCamelCase(body.data),
          classified: {
            ...toCamelCase(body.data.classified),
            fieldValues: body.data.classified.field_values
          },
          fieldValues: body.data.classified.field_values,
          incompleteFieldValues: body.data.classified.incomplete_field_values
        },
        page: toCamelCase(body._page)
      }))
      .send()
  }
}
